/**
 * @description: 管家业绩汇总报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="tsr-gyh-report">
        <div class="gyh-list">
            <el-form :inline="true" size="small" :model="gyh_list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="gyh_list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="gyh_list_form.start_time"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="gyh_list_form.end_time"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="gyh_list_form.shop_id" filterable placeholder="请选择门店" @change="getGroup">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="组别">
                    <el-select v-model="gyh_list_form.group_id" filterable clearable placeholder="请选择组别">
                        <el-option v-for="item in group_list" :key="item.group_id" :label="item.group_name" :value="item.group_id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="管家">
                    <el-input placeholder="请输入管家名称" v-model="gyh_list_form.shopping_guide_name"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getGyhList(1)">查询</el-button>
                    <el-button @click="gyhExportSet">导出</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="gyh_list">
                <el-table-column prop="shop_name" label="门店"></el-table-column>
                <el-table-column prop="group_name" label="组别"></el-table-column>
                <el-table-column prop="shopping_guide_name" label="管家"></el-table-column>
                <el-table-column prop="amount" label="业绩金额"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span class="text-blue" @click="setPageParams(scope.row)">查看明细</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-row">
                <div>
                    <label class="list-label-4">业绩总额:</label>
                    <div class="list-total">{{gyh_amount}}</div>
                </div>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="gyh_list_page"
                    :total="gyh_list_total"
                    @current-change="getGyhList">
                </el-pagination>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="export-wrap" ref="gyh_list_export">
                <h2>请选择导出报表需要的显示的字段</h2>
                <el-checkbox :indeterminate="gyh_export_sign" v-model="gyh_export_all" @change="gyhExportAll">全选</el-checkbox>
                <el-checkbox-group v-model="gyh_export_ids" @change="gyhExportChange">
                    <el-checkbox label="shop_name">门店</el-checkbox>
                    <el-checkbox label="group_name">组别</el-checkbox>
                    <el-checkbox label="shopping_guide_name">管家</el-checkbox>
                    <el-checkbox label="amount">业绩金额</el-checkbox>
                </el-checkbox-group>
                <h2>请选择导出报表的文件格式</h2>
                <el-radio v-model="gyh_export_type" label="1">excel表格</el-radio>
                <el-radio v-model="gyh_export_type" label="2">pdf文件</el-radio>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                gyh_mym_menu: {},
                loading: false,
                shop_list: [],
                group_list: [],
                gyh_list_form: {
                    start_time: moment().subtract(1, 'day').format('YYYY-MM-DD 08:00'),
                    end_time: moment().format('YYYY-MM-DD 08:00'),
                    shop_id: '',
                    group_id: '',
                    shopping_guide_name: ''
				},
                gyh_amount: '',
				gyh_list: [],
				gyh_list_page: 1,
                gyh_list_total: 0,
                gyh_export_sign: false,
				gyh_export_all: false,
                gyh_export_ids: [],
                gyh_export_list: ['shop_name', 'group_name', 'shopping_guide_name', 'amount'],
                gyh_export_type: '1',
            }
        },
        computed: {
            menunew() {
				return JSON.parse(this.$store.state.menunew)
			}
        },
        mounted: function() {
            // 跳转菜单
			this.getPageMenu()
            this.initDate()
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.gyh_list_form.shop_id = this.shop_list[0].id
                this.getGroup(this.shop_list[0].id)
                this.getGyhList(1)
            })
        },
        methods: {
            // 跳转菜单
			getPageMenu: function() {
				this.menunew.forEach(i => {
					if(i.id == '544') { // 报表
						i.submenu.forEach(j => {
							if(j.id == '1239') { // 门票营业报表
                                j.submenu.forEach(k => {
                                    if(k.id == '1240') {
                                        // 门票营业明细报表
                                        this.gyh_mym_menu = k
                                    }
                                })
							}
						})
					}
				})
			},
			// 跳转参数
			setPageParams(row) {
				const obj = {
					name: 'tsr_mym_report',
					params: {
                        start_time: this.gyh_list_form.start_time,
                        end_time: this.gyh_list_form.end_time,
                        shop_id: row.shop_id,
                        shopping_guide: row.shopping_guide,
                        deduct_group_price: ''
					}
				}
				this.$emit("pageLink", this.gyh_mym_menu, obj)
			},
            // 初始化日期插件
            initDate: function() {
                const _this = this
                $(_this.$refs.gyh_list_date).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().subtract(1, 'day').toDate(),
                    endDate: moment().toDate(),
                    maxDate: moment().add(1, 'day').toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.gyh_list_form.start_time = start.format('YYYY-MM-DD 08:00')
                    _this.gyh_list_form.end_time = end.format('YYYY-MM-DD 08:00')
                })
            },
            // 门店
            getShop: function(resolve) {
                const _this = this

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result
                        _this.shop_list.shift()
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this)
                        layer.msg(res.data.response.error_msg)
                    }
                })
                .catch(err => {
                    layer.msg('出错啦')
                })
            },
            // 组别
            getGroup: function(shop_id) {
                const _this = this;

                _this.gyh_list_form.group_id = '';
                Vue.axios.post('FinanceReport/getGroupSearchList', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id,
                            "key_word": 'user'
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.group_list = res.data.response.result;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },



            getGyhList(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('TicketOrder/getShoppingGuideCount', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_time": _this.gyh_list_form.start_time,
                            "end_time": _this.gyh_list_form.end_time,
							"shop_id": _this.gyh_list_form.shop_id,
							"group_id": _this.gyh_list_form.group_id,
							"shopping_guide_name": _this.gyh_list_form.shopping_guide_name
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.gyh_list_total = Number(res.data.response.result.total_data.total)
							_this.gyh_amount = res.data.response.result.total_data.amount
						}
						_this.gyh_list = res.data.response.result.rows
						_this.loading = false
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            // 导出
            gyhExportAll(val) {
				this.gyh_export_ids = val ? this.gyh_export_list : [];
				this.gyh_export_sign = false;
			},
			gyhExportChange(val) {
				const len = val.length;
				this.gyh_export_all = len === this.gyh_export_list.length;
				this.gyh_export_sign = len > 0 && len < this.gyh_export_list.length;
			},
            gyhExportSet: function() {
                const _this = this;

                Vue.axios.post('FinanceReport/getExportSet', {
					"header": Vue.request_header,
					"request": {
						"param": {
                            "report_type": "TicketOrder/exportShoppingGuideCount"
                        }
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(res.data.response.result) {
                            _this.gyh_export_ids = res.data.response.result.export_fields;
                            _this.gyh_export_type = res.data.response.result.export_type;
                        } else {
                            _this.gyh_export_ids = _this.gyh_export_list;
                            _this.gyh_export_type = '1';
                        }
                        _this.gyhExportChange(_this.gyh_export_ids);
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
                });
                // 弹窗
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['800px', ''], // 宽高
                    content: $(_this.$refs.gyh_list_export)
                }, function() {
                    _this.gyhExport();
                });
            },
            gyhExport: function() {
                window.location.href = Vue.ctUrl + "TicketOrder/exportShoppingGuideCount" +
                    "?start_time=" + this.gyh_list_form.start_time +
                    "&end_time=" + this.gyh_list_form.end_time +
                    "&shop_id=" + this.gyh_list_form.shop_id +
                    "&group_id=" + this.gyh_list_form.group_id +
                    "&shopping_guide_name=" + this.gyh_list_form.shopping_guide_name +
                    "&export_fields=" + JSON.stringify(this.gyh_export_ids) +
                    "&export_type=" + this.gyh_export_type;
                layer.closeAll();
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scoped>
    .export-wrap {
        h2 {
            margin: 20px 0 15px 0;
            font-size: 16px;
        }
    }
</style>